/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArchivingGkReportOverviewUsageDTO } from './archiving-gk-report-overview-usage-dto';


export interface ArchivingGkReportOverviewDTO { 
    /**
     * Start of usage period returned
     */
    periodStart?: string;
    /**
     * End of usage period returned
     */
    periodEnd?: string;
    usage?: ArchivingGkReportOverviewUsageDTO;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
}

export class ClsArchivingGkReportOverviewDTO { 
    /**
     * Start of usage period returned
     */
    periodStart?: string = undefined;
    /**
     * End of usage period returned
     */
    periodEnd?: string = undefined;
    usage?: ArchivingGkReportOverviewUsageDTO = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
}

